import Vue from "vue";
const vm = Vue.prototype;

export const state = () => ({
  employees: [],
  stats: [],
});

export const mutations = {
  SET_EMPLOYEES(state, payload) {
    state.employees = vm.$toArray(payload);
  },
  SET_EMPLOYEE_STATS(state, payload) {
    state.stats = vm.$toArray(payload);
  },
};

export const actions = {
  async INIT_EMPLOYEES({ commit }, options = {}) {
    const { itemsPerPage = 100, search = "" } = options;
    const page = Number(options.page - 1) || 0;
    const senc = search ? encodeURI(search) : null;

    const query = `?page=${page}&size=${itemsPerPage}&name=${senc}`;
    let totalItemsCount = 0;

    const data = await vm.$axios.$get(`admin/referral-employee${query}`);
    if (data) {
      commit("SET_EMPLOYEES", data.content);
      totalItemsCount = data.totalElements;
    }

    return totalItemsCount;
  },

  async EMPLOYEE_BY_ID(ctx, { id }) {
    return await vm.$axios.$get(`admin/referral-employee/${id}`);
  },

  async ADD_EMPLOYEE(ctx, employee) {
    const url = "admin/referral-employee";
    const method = employee.id ? "$post" : "$put";
    return await vm.$axios[method](url, employee);
  },

  async EMPLOYEE_STATUS(ctx, { id, active }) {
    const url = `admin/referral-employee/${id}/`;
    const method = !active ? "deactivation" : "activation";
    return await vm.$axios.$post(url + method);
  },

  async REGENERATE_TOKEN(ctx, { id }) {
    return await vm.$axios.$post(`admin/referral-employee/${id}/regenerate-token`);
  },

  // Issue a fresh /admission desk password; returns the employee DTO with the new password.
  async REGENERATE_PASSWORD(ctx, { id }) {
    return await vm.$axios.$post(`admin/referral-employee/${id}/regenerate-password`);
  },

  // Hard-delete. Backend refuses (409 → snackbar) if the employee still has referred applicants.
  async DELETE_EMPLOYEE(ctx, { id }) {
    return await vm.$axios.$delete(`admin/referral-employee/${id}`);
  },

  // Aggregate stats for all employees (one row per employee)
  async INIT_EMPLOYEE_STATS({ commit }) {
    const data = await vm.$axios.$get(`admin/referral-employee/stats`);
    commit("SET_EMPLOYEE_STATS", data);
    return data != null;
  },

  // Single employee stats, optional from/to (yyyy-MM-dd) period filter
  async EMPLOYEE_STAT_BY_ID(ctx, { id, from, to }) {
    const params = [];
    if (from) params.push(`from=${from}`);
    if (to) params.push(`to=${to}`);
    const query = params.length ? `?${params.join("&")}` : "";
    return await vm.$axios.$get(`admin/referral-employee/${id}/stats${query}`);
  },

  // Daily acquisition buckets for the trend chart
  async EMPLOYEE_TIMESERIES(ctx, { id, from, to }) {
    const params = [];
    if (from) params.push(`from=${from}`);
    if (to) params.push(`to=${to}`);
    const query = params.length ? `?${params.join("&")}` : "";
    return await vm.$axios.$get(`admin/referral-employee/${id}/timeseries${query}`);
  },

  // Applicants attributed to this employee (the referred-students table), optional from/to window
  async EMPLOYEE_STUDENTS(ctx, { id, from, to }) {
    const params = [];
    if (from) params.push(`from=${from}`);
    if (to) params.push(`to=${to}`);
    const query = params.length ? `?${params.join("&")}` : "";
    return await vm.$axios.$get(`admin/referral-employee/${id}/students${query}`);
  },

  // Excel of all referred students' 2026 contracts (employee info on each row). Returns a Blob.
  async EXPORT_CONTRACTS() {
    return await vm.$axios.$get(`admin/referral-employee/export`, {
      responseType: "blob",
    });
  },
};

export const getters = {
  GET_EMPLOYEES: (state) => state.employees,
  GET_EMPLOYEE_STATS: (state) => state.stats,
};
